import { useCallback } from 'react';

interface UseContactSupportOptions {
  subject: string;
  fallbackEmail?: string;
}

export function useContactSupport({
  subject,
  fallbackEmail = 'hello@joinwaterlily.com',
}: UseContactSupportOptions) {
  const contactSupport = useCallback(() => {
    if ('Intercom' in window) {
      (window as any).Intercom('show');
    } else {
      const encodedSubject = encodeURIComponent(subject);
      const mailtoUrl = `mailto:${fallbackEmail}?subject=${encodedSubject}`;
      (window as Window).open(mailtoUrl, '_blank');
    }
  }, [subject, fallbackEmail]);

  return contactSupport;
}
